// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --selectionGrey: #666666;
}

.ge-commands {
  grid-row: 1;
  grid-column: 1;
  user-select: none;
}
.ge-commands * {
  font-family: "acumin-pro-condensed";
  font-weight: 600;
  font-size: 12px;
}
.ge-commands .copy {
  display: none;
}
.ge-commands .commands-left {
  float: left;
  display: flex;
}
.ge-commands .commands-right {
  float: right;
  display: flex;
}
.ge-commands .commands-right .beta-flag {
  height: 30px;
  position: relative;
  left: -15px;
}
.ge-commands.background-ts .command-button img,
.ge-commands.background-ts .command-dropdown img {
  filter: invert(64%) sepia(78%) saturate(940%) hue-rotate(323deg) brightness(105%) contrast(103%);
}
.ge-commands.background-ts .command-button .command-dropdown-active,
.ge-commands.background-ts .command-dropdown .command-dropdown-active {
  color: #333333;
}
.ge-commands.background-ts .command-button:hover img, .ge-commands.background-ts .command-button.activated img,
.ge-commands.background-ts .command-dropdown:hover img,
.ge-commands.background-ts .command-dropdown.activated img {
  filter: invert(34%) sepia(21%) saturate(3832%) hue-rotate(324deg) brightness(88%) contrast(82%) !important;
}
.ge-commands.background-js .command-button img,
.ge-commands.background-js .command-dropdown img {
  filter: invert(57%) sepia(80%) saturate(2031%) hue-rotate(215deg);
}
.ge-commands.background-js .command-button .command-dropdown-active,
.ge-commands.background-js .command-dropdown .command-dropdown-active {
  color: #333333;
}
.ge-commands.background-js .command-button:hover img, .ge-commands.background-js .command-button.activated img,
.ge-commands.background-js .command-dropdown:hover img,
.ge-commands.background-js .command-dropdown.activated img {
  filter: invert(17%) !important;
}
.ge-commands .command-button {
  cursor: pointer;
  width: 55px;
  height: 55px;
}
.ge-commands .command-button .command-label {
  display: none;
}
.ge-commands .command-button .command-button-icon {
  height: 100%;
  width: 100%;
  display: grid;
  color: white;
  align-content: center;
  justify-content: center;
}
.ge-commands .command-button .active {
  transform-origin: center;
  background-color: var(--selectionGrey);
}
.ge-commands .command-button img.active {
  background-color: var(--selectionGrey);
}
.ge-commands .command-button:hover {
  background-color: var(--selectionGrey);
}
.ge-commands .copyAndDeleteDisabled {
  pointer-events: none;
  color: black;
}
.ge-commands .pasteDisabled {
  pointer-events: none;
  color: black;
}
.ge-commands .command-dropdown-root {
  position: relative;
  text-transform: uppercase;
  z-index: 1;
}
.ge-commands .command-dropdown {
  cursor: pointer;
  width: 55px;
  height: 55px;
}
.ge-commands .command-dropdown .command-dropdown-icon {
  height: 100%;
  width: 100%;
  display: grid;
  align-content: center;
  justify-content: center;
}
.ge-commands .command-dropdown .command-dropdown-active {
  height: 100%;
  width: 100%;
  display: grid;
  align-content: center;
  justify-content: center;
  font-size: 14px;
}
.ge-commands .command-dropdown:hover, .ge-commands .command-dropdown.activated {
  background-color: #666666;
  color: black;
}
.ge-commands .command-dropdown:active {
  transform-origin: center;
  transform: scale(0.95);
}
.ge-commands .command-dropdown-blocker {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: scale(1);
  z-index: 1;
}
.ge-commands.background-js .command-dropdown-content {
  background: #333333;
}
.ge-commands.background-js .command-dropdown-content .command-dropdown-label:hover {
  background: #333333;
}
.ge-commands.background-ts .command-dropdown-content .command-dropdown-label:hover {
  background: #333333;
}
.ge-commands .command-dropdown-content {
  background: #333333;
  position: absolute;
  top: 55px;
  width: 55px;
  transform: scale(1);
}
.ge-commands .command-dropdown-content.toRight {
  width: 120px;
}
.ge-commands .command-dropdown-content .command-dropdown-label {
  color: white;
  padding: 5px;
  padding-left: 7px;
  height: 35px;
  font-size: 18px;
  display: grid;
  align-items: center;
  cursor: pointer;
  user-select: none;
  grid-template-columns: 1fr 20px;
  grid-template-rows: 100%;
  position: relative;
}
.ge-commands .command-dropdown-content .command-dropdown-label.active {
  font-weight: bold;
  font-size: 20px;
}
.ge-commands .command-dropdown-content .command-dropdown-label:hover {
  background: var(--selectionGrey);
}
.ge-commands .command-dropdown-content .command-dropdown-label:hover .sub-items {
  display: block;
}
.ge-commands .command-dropdown-content .command-dropdown-label .command-dropdown-label-text {
  font-size: 12px;
  grid-column: 1;
  grid-row: 1;
}
.ge-commands .command-dropdown-content .command-dropdown-label .command-dropdown-label-check {
  grid-column: 2;
  grid-row: 1;
}
.ge-commands .command-dropdown-content .command-dropdown-label .command-dropdown-arrow {
  grid-column: 2;
  grid-row: 1;
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 10px;
  padding-left: 4px;
}
.ge-commands .command-dropdown-content .command-dropdown-label .sub-items {
  position: absolute;
  left: 200px;
  top: 0;
  width: 150px;
  display: none;
}
.ge-commands .command-dropdown-content .command-dropdown-label .sub-items.background-js {
  background: #bfabff;
}
.ge-commands .command-dropdown-content .command-dropdown-label .sub-items.background-js .sub-item:hover {
  background-color: #333333;
  color: white;
}
.ge-commands .command-dropdown-content .command-dropdown-label .sub-items.background-ts {
  background: #333333;
}
.ge-commands .command-dropdown-content .command-dropdown-label .sub-items.background-ts .sub-item:hover {
  background-color: #333333;
  color: white;
}
.ge-commands .command-dropdown-content .command-dropdown-label .sub-items .sub-item {
  color: white;
  padding: 5px;
  padding-left: 10px;
  height: 35px;
  display: grid;
}
.ge-commands .command-dropdown-content .command-dropdown-label .sub-items .sub-item.checked {
  background: white;
  color: black;
}
.ge-commands .command-dropdown-content .buttonLine {
  color: white;
  padding: 5px;
  padding-left: 7px;
  height: 35px;
  font-size: 18px;
  display: grid;
  align-items: center;
  cursor: pointer;
  user-select: none;
  grid-template-columns: 1fr 20px;
  grid-template-rows: 100%;
  position: relative;
  font-size: 12px;
  grid-column: 1;
  grid-row: 1;
}
.ge-commands .command-dropdown-content .buttonLine input[type=file] {
  display: none;
}
.ge-commands .command-dropdown-content .buttonLine.active {
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}
.ge-commands .command-dropdown-content .buttonLine:hover {
  background: var(--selectionGrey);
  cursor: pointer;
}
.ge-commands .command-dropdown-content .buttonLine:hover .sub-items {
  display: block;
}
.ge-commands .command-dropdown-content .buttonLine .file-upload {
  cursor: pointer;
}
.ge-commands .divider {
  display: flex;
  align-items: center;
  border-right: 1px solid black;
  color: white;
}
.ge-commands .divider:last-of-type {
  border-right: none;
}
.ge-commands .divider.padded {
  padding-left: 10px;
  padding-right: 10px;
}
.ge-commands .floatLine,
.ge-commands .checkBoxLine {
  display: flex;
  align-items: center;
}
.ge-commands .floatLine .copy,
.ge-commands .checkBoxLine .copy {
  display: none;
}
.ge-commands .checkBoxLine .icon {
  filter: brightness(10);
}
.ge-commands .checkBoxLine .hidden {
  display: none;
}
.ge-commands .checkBoxLine .checkBox {
  height: 40px;
}
.ge-commands .checkBoxLine .copy {
  display: none;
}
.ge-commands .color3Line {
  display: grid;
}
.ge-commands .color3Line .firstLine {
  display: flex;
  align-items: center;
}
.ge-commands .color3Line .firstLine .label {
  padding-right: 5px;
}
.ge-commands .color3Line .firstLine .floatLine .value {
  padding-left: 2px;
}
.ge-commands .color3Line .firstLine .copy {
  display: none;
}
.ge-commands .color3Line .firstLine .expand {
  display: none;
}
.ge-commands .color3Line .secondLine {
  display: grid;
  padding-right: 5px;
  border-left: 1px solid rgb(51, 122, 183);
}
.ge-commands .color3Line .secondLine .numeric {
  display: grid;
  grid-template-columns: 1fr auto;
}
.ge-commands .color3Line .secondLine .numeric-label {
  text-align: right;
  grid-column: 1;
  display: flex;
  align-items: center;
  justify-self: right;
  margin-right: 10px;
}
.ge-commands .color3Line .secondLine .numeric-value {
  width: 120px;
  grid-column: 2;
  display: flex;
  align-items: center;
  border: 1px solid rgb(51, 122, 183);
}
.ge-commands .color-picker {
  height: 26px;
  width: 26px;
}
.ge-commands .color-picker .color-rect-background {
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  border: 1px solid white;
  cursor: pointer;
  background: repeating-conic-gradient(#e2e2e2 0% 25%, white 0% 50%) 50%/100% 100%;
}
.ge-commands .color-picker .color-rect-background .color-rect {
  height: 100%;
}
.ge-commands .color-picker .color-picker-cover {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 2;
}
.ge-commands .color-picker .color-picker-float {
  position: absolute;
  outline: 1px solid black;
}
.ge-commands .color-picker .color-picker-container {
  background-color: #e2e2e2;
}
.ge-commands .color-picker input:focus {
  outline-color: black;
}
.ge-commands .floatLine input,
.ge-commands .listLine select {
  background-color: #000000;
  color: white;
  padding: 5px;
  border: none;
}
.ge-commands input,
.ge-commands .listLine select {
  outline-color: transparent;
  outline-width: 1px;
  outline-offset: -1px;
  outline-style: solid;
  transition: 0.2s outline;
  border: none;
}
.ge-commands .floatLine .value {
  position: relative;
  margin: 5px;
}
.ge-commands .floatLine input:focus {
  outline-color: white;
}
.ge-commands .listLine select {
  width: 150px;
}
.ge-commands .hasArrows .arrows {
  display: none;
  position: absolute;
  right: 0;
  top: 0;
  flex-direction: column;
  cursor: grab;
  filter: brightness(10);
}
.ge-commands .hasArrows .arrows .downArrowIcon,
.ge-commands .hasArrows .arrows .upArrowIcon {
  width: 13px;
  height: 13px;
}
.ge-commands .hasArrows:hover .arrows, .ge-commands .hasArrows:focus .arrows, .ge-commands .hasArrows.dragging .arrows {
  display: flex;
}
.ge-commands .hasArrows .arrows:hover {
  background-color: var(--buttonHoverBackground);
  filter: none;
}
.ge-commands .hasArrows.dragging .arrows {
  background-color: var(--buttonPressedBackground);
}
.ge-commands .hasArrows.dragging .arrows .downArrowIcon,
.ge-commands .hasArrows.dragging .arrows .upArrowIcon {
  filter: none;
}
.ge-commands .hasArrows input::-webkit-outer-spin-button,
.ge-commands .hasArrows input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.ge-commands .hasArrows input[type=number] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./../../../tools/guiEditor/dist/scss/commandBar.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;AACJ;;AAEA;EACI,WAAA;EACA,cAAA;EACA,iBAAA;AACJ;AAAI;EACI,mCAAA;EACA,gBAAA;EACA,eAAA;AAER;AACI;EACI,aAAA;AACR;AAEI;EACI,WAAA;EACA,aAAA;AAAR;AAGI;EACI,YAAA;EACA,aAAA;AADR;AAEQ;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AAAZ;AAOY;;EACI,gGAAA;AAJhB;AAOY;;EACI,cAAA;AAJhB;AASgB;;;EACI,0GAAA;AALpB;AAcY;;EACI,iEAAA;AAXhB;AAcY;;EACI,cAAA;AAXhB;AAgBgB;;;EACI,8BAAA;AAZpB;AAkBI;EACI,eAAA;EACA,WAAA;EACA,YAAA;AAhBR;AAkBQ;EACI,aAAA;AAhBZ;AAmBQ;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;AAjBZ;AAoBQ;EACI,wBAAA;EACA,sCAAA;AAlBZ;AAsBY;EACI,sCAAA;AApBhB;AAwBI;EACI,sCAAA;AAtBR;AAwBI;EACI,oBAAA;EACA,YAAA;AAtBR;AAwBI;EACI,oBAAA;EACA,YAAA;AAtBR;AAwBI;EACI,kBAAA;EACA,yBAAA;EACA,UAAA;AAtBR;AAyBI;EACI,eAAA;EACA,WAAA;EACA,YAAA;AAvBR;AAyBQ;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AAvBZ;AA0BQ;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,eAAA;AAxBZ;AA2BQ;EAEI,yBAAA;EACA,YAAA;AA1BZ;AA6BQ;EACI,wBAAA;EACA,sBAAA;AA3BZ;AA+BI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;AA7BR;AAiCQ;EACI,mBAAA;AA/BZ;AAiCgB;EACI,mBAAA;AA/BpB;AAwCgB;EACI,mBAAA;AAtCpB;AA4CI;EACI,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AA1CR;AA4CQ;EACI,YAAA;AA1CZ;AA6CQ;EACI,YAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,wBAAA;EACA,kBAAA;AA3CZ;AA6CY;EACI,iBAAA;EACA,eAAA;AA3ChB;AA8CY;EACI,gCAAA;AA5ChB;AA6CgB;EACI,cAAA;AA3CpB;AA+CY;EACI,eAAA;EACA,cAAA;EACA,WAAA;AA7ChB;AAgDY;EACI,cAAA;EACA,WAAA;AA9ChB;AAiDY;EACI,cAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;AA/ChB;AAkDY;EACI,kBAAA;EACA,WAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;AAhDhB;AAkDgB;EACI,mBAAA;AAhDpB;AAkDwB;EACI,yBAAA;EACA,YAAA;AAhD5B;AAqDgB;EACI,mBAAA;AAnDpB;AAqDwB;EACI,yBAAA;EACA,YAAA;AAnD5B;AAwDgB;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAtDpB;AAwDoB;EACI,iBAAA;EACA,YAAA;AAtDxB;AA4DQ;EACI,YAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;AA1DZ;AA2DY;EACI,aAAA;AAzDhB;AA4DY;EACI,iBAAA;EACA,eAAA;EACA,eAAA;AA1DhB;AA6DY;EACI,gCAAA;EACA,eAAA;AA3DhB;AA4DgB;EACI,cAAA;AA1DpB;AA8DY;EACI,eAAA;AA5DhB;AAiEI;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;AA/DR;AAgEQ;EACI,kBAAA;AA9DZ;AAgEQ;EACI,kBAAA;EACA,mBAAA;AA9DZ;AAkEI;;EAEI,aAAA;EACA,mBAAA;AAhER;AAkEQ;;EACI,aAAA;AA/DZ;AAoEQ;EACI,sBAAA;AAlEZ;AAqEQ;EACI,aAAA;AAnEZ;AAsEQ;EACI,YAAA;AApEZ;AAuEQ;EACI,aAAA;AArEZ;AAyEI;EACI,aAAA;AAvER;AAyEQ;EACI,aAAA;EACA,mBAAA;AAvEZ;AAyEY;EACI,kBAAA;AAvEhB;AA2EgB;EACI,iBAAA;AAzEpB;AA6EY;EACI,aAAA;AA3EhB;AA8EY;EACI,aAAA;AA5EhB;AAgFQ;EACI,aAAA;EACA,kBAAA;EACA,wCAAA;AA9EZ;AAgFY;EACI,aAAA;EACA,+BAAA;AA9EhB;AAiFY;EACI,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AA/EhB;AAkFY;EACI,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;AAhFhB;AAqFI;EACI,YAAA;EACA,WAAA;AAnFR;AAqFQ;EACI,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,eAAA;EACA,gFAAA;AAnFZ;AAoFY;EACI,YAAA;AAlFhB;AAsFQ;EACI,eAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AApFZ;AAuFQ;EACI,kBAAA;EACA,wBAAA;AArFZ;AAwFQ;EACI,yBAAA;AAtFZ;AAyFQ;EACI,oBAAA;AAvFZ;AA2FI;;EAEI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AAzFR;AA4FI;;EAEI,0BAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,wBAAA;EACA,YAAA;AA1FR;AA6FI;EACI,kBAAA;EACA,WAAA;AA3FR;AA8FI;EACI,oBAAA;AA5FR;AA+FI;EACI,YAAA;AA7FR;AAiGQ;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;AA/FZ;AAgGY;;EAEI,WAAA;EACA,YAAA;AA9FhB;AAiGQ;EAGI,aAAA;AAjGZ;AAmGQ;EACI,8CAAA;EACA,YAAA;AAjGZ;AAmGQ;EACI,gDAAA;AAjGZ;AAkGY;;EAEI,YAAA;AAhGhB;AAoGI;;EAEI,wBAAA;EACA,SAAA;AAlGR;AAqGI;EACI,0BAAA;AAnGR","sourcesContent":[":root {\r\n    --selectionGrey: #666666;\r\n}\r\n\r\n.ge-commands {\r\n    grid-row: 1;\r\n    grid-column: 1;\r\n    user-select: none;\r\n    * {\r\n        font-family: \"acumin-pro-condensed\";\r\n        font-weight: 600;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .copy {\r\n        display: none;\r\n    }\r\n\r\n    .commands-left {\r\n        float: left;\r\n        display: flex;\r\n    }\r\n\r\n    .commands-right {\r\n        float: right;\r\n        display: flex;\r\n        .beta-flag {\r\n            height: 30px;\r\n            position: relative;\r\n            left: -15px;\r\n        }\r\n    }\r\n\r\n    &.background-ts {\r\n        .command-button,\r\n        .command-dropdown {\r\n            img {\r\n                filter: invert(64%) sepia(78%) saturate(940%) hue-rotate(323deg) brightness(105%) contrast(103%);\r\n            }\r\n\r\n            .command-dropdown-active {\r\n                color: #333333;\r\n            }\r\n\r\n            &:hover,\r\n            &.activated {\r\n                img {\r\n                    filter: invert(34%) sepia(21%) saturate(3832%) hue-rotate(324deg) brightness(88%) contrast(82%) !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.background-js {\r\n        .command-button,\r\n        .command-dropdown {\r\n            img {\r\n                filter: invert(57%) sepia(80%) saturate(2031%) hue-rotate(215deg);\r\n            }\r\n\r\n            .command-dropdown-active {\r\n                color: #333333;\r\n            }\r\n\r\n            &:hover,\r\n            &.activated {\r\n                img {\r\n                    filter: invert(17%) !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .command-button {\r\n        cursor: pointer;\r\n        width: 55px;\r\n        height: 55px;\r\n\r\n        .command-label {\r\n            display: none;\r\n        }\r\n\r\n        .command-button-icon {\r\n            height: 100%;\r\n            width: 100%;\r\n            display: grid;\r\n            color: white;\r\n            align-content: center;\r\n            justify-content: center;\r\n        }\r\n\r\n        .active {\r\n            transform-origin: center;\r\n            background-color: var(--selectionGrey);\r\n        }\r\n\r\n        img {\r\n            &.active {\r\n                background-color: var(--selectionGrey);\r\n            }\r\n        }\r\n    }\r\n    .command-button:hover {\r\n        background-color: var(--selectionGrey);\r\n    }\r\n    .copyAndDeleteDisabled {\r\n        pointer-events: none;\r\n        color: black;\r\n    }\r\n    .pasteDisabled {\r\n        pointer-events: none;\r\n        color: black;\r\n    }\r\n    .command-dropdown-root {\r\n        position: relative;\r\n        text-transform: uppercase;\r\n        z-index: 1;\r\n    }\r\n\r\n    .command-dropdown {\r\n        cursor: pointer;\r\n        width: 55px;\r\n        height: 55px;\r\n\r\n        .command-dropdown-icon {\r\n            height: 100%;\r\n            width: 100%;\r\n            display: grid;\r\n            align-content: center;\r\n            justify-content: center;\r\n        }\r\n\r\n        .command-dropdown-active {\r\n            height: 100%;\r\n            width: 100%;\r\n            display: grid;\r\n            align-content: center;\r\n            justify-content: center;\r\n            font-size: 14px;\r\n        }\r\n\r\n        &:hover,\r\n        &.activated {\r\n            background-color: #666666;\r\n            color: black;\r\n        }\r\n\r\n        &:active {\r\n            transform-origin: center;\r\n            transform: scale(0.95);\r\n        }\r\n    }\r\n\r\n    .command-dropdown-blocker {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        transform: scale(1);\r\n        z-index: 1;\r\n    }\r\n\r\n    &.background-js {\r\n        .command-dropdown-content {\r\n            background: #333333;\r\n            .command-dropdown-label {\r\n                &:hover {\r\n                    background: #333333;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.background-ts {\r\n        .command-dropdown-content {\r\n            .command-dropdown-label {\r\n                &:hover {\r\n                    background: #333333;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .command-dropdown-content {\r\n        background: #333333;\r\n        position: absolute;\r\n        top: 55px;\r\n        width: 55px;\r\n        transform: scale(1);\r\n\r\n        &.toRight {\r\n            width: 120px;\r\n        }\r\n\r\n        .command-dropdown-label {\r\n            color: white;\r\n            padding: 5px;\r\n            padding-left: 7px;\r\n            height: 35px;\r\n            font-size: 18px;\r\n            display: grid;\r\n            align-items: center;\r\n            cursor: pointer;\r\n            user-select: none;\r\n            grid-template-columns: 1fr 20px;\r\n            grid-template-rows: 100%;\r\n            position: relative;\r\n\r\n            &.active {\r\n                font-weight: bold;\r\n                font-size: 20px;\r\n            }\r\n\r\n            &:hover {\r\n                background: var(--selectionGrey);\r\n                .sub-items {\r\n                    display: block;\r\n                }\r\n            }\r\n\r\n            .command-dropdown-label-text {\r\n                font-size: 12px;\r\n                grid-column: 1;\r\n                grid-row: 1;\r\n            }\r\n\r\n            .command-dropdown-label-check {\r\n                grid-column: 2;\r\n                grid-row: 1;\r\n            }\r\n\r\n            .command-dropdown-arrow {\r\n                grid-column: 2;\r\n                grid-row: 1;\r\n                font-size: 20px;\r\n                font-weight: bold;\r\n                padding-bottom: 10px;\r\n                padding-left: 4px;\r\n            }\r\n\r\n            .sub-items {\r\n                position: absolute;\r\n                left: 200px;\r\n                top: 0;\r\n                width: 150px;\r\n                display: none;\r\n\r\n                &.background-js {\r\n                    background: #bfabff;\r\n                    .sub-item {\r\n                        &:hover {\r\n                            background-color: #333333;\r\n                            color: white;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                &.background-ts {\r\n                    background: #333333;\r\n                    .sub-item {\r\n                        &:hover {\r\n                            background-color: #333333;\r\n                            color: white;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .sub-item {\r\n                    color: white;\r\n                    padding: 5px;\r\n                    padding-left: 10px;\r\n                    height: 35px;\r\n                    display: grid;\r\n\r\n                    &.checked {\r\n                        background: white;\r\n                        color: black;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .buttonLine {\r\n            color: white;\r\n            padding: 5px;\r\n            padding-left: 7px;\r\n            height: 35px;\r\n            font-size: 18px;\r\n            display: grid;\r\n            align-items: center;\r\n            cursor: pointer;\r\n            user-select: none;\r\n            grid-template-columns: 1fr 20px;\r\n            grid-template-rows: 100%;\r\n            position: relative;\r\n            font-size: 12px;\r\n            grid-column: 1;\r\n            grid-row: 1;\r\n            input[type=\"file\"] {\r\n                display: none;\r\n            }\r\n\r\n            &.active {\r\n                font-weight: bold;\r\n                font-size: 20px;\r\n                cursor: pointer;\r\n            }\r\n\r\n            &:hover {\r\n                background: var(--selectionGrey);\r\n                cursor: pointer;\r\n                .sub-items {\r\n                    display: block;\r\n                }\r\n            }\r\n\r\n            .file-upload {\r\n                cursor: pointer;\r\n            }\r\n        }\r\n    }\r\n\r\n    .divider {\r\n        display: flex;\r\n        align-items: center;\r\n        border-right: 1px solid black;\r\n        color: white;\r\n        &:last-of-type {\r\n            border-right: none;\r\n        }\r\n        &.padded {\r\n            padding-left: 10px;\r\n            padding-right: 10px;\r\n        }\r\n    }\r\n\r\n    .floatLine,\r\n    .checkBoxLine {\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        .copy {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    .checkBoxLine {\r\n        .icon {\r\n            filter: brightness(10);\r\n        }\r\n\r\n        .hidden {\r\n            display: none;\r\n        }\r\n\r\n        .checkBox {\r\n            height: 40px;\r\n        }\r\n\r\n        .copy {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    .color3Line {\r\n        display: grid;\r\n\r\n        .firstLine {\r\n            display: flex;\r\n            align-items: center;\r\n\r\n            .label {\r\n                padding-right: 5px;\r\n            }\r\n\r\n            .floatLine {\r\n                .value {\r\n                    padding-left: 2px;\r\n                }\r\n            }\r\n\r\n            .copy {\r\n                display: none;\r\n            }\r\n\r\n            .expand {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .secondLine {\r\n            display: grid;\r\n            padding-right: 5px;\r\n            border-left: 1px solid rgb(51, 122, 183);\r\n\r\n            .numeric {\r\n                display: grid;\r\n                grid-template-columns: 1fr auto;\r\n            }\r\n\r\n            .numeric-label {\r\n                text-align: right;\r\n                grid-column: 1;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-self: right;\r\n                margin-right: 10px;\r\n            }\r\n\r\n            .numeric-value {\r\n                width: 120px;\r\n                grid-column: 2;\r\n                display: flex;\r\n                align-items: center;\r\n                border: 1px solid rgb(51, 122, 183);\r\n            }\r\n        }\r\n    }\r\n\r\n    .color-picker {\r\n        height: 26px;\r\n        width: 26px;\r\n\r\n        .color-rect-background {\r\n            width: calc(100% - 2px);\r\n            height: calc(100% - 2px);\r\n            border: 1px solid white;\r\n            cursor: pointer;\r\n            background: repeating-conic-gradient(#e2e2e2 0% 25%, white 0% 50%) 50% / 100% 100%;\r\n            .color-rect {\r\n                height: 100%;\r\n            }\r\n        }\r\n\r\n        .color-picker-cover {\r\n            position: fixed;\r\n            top: 0px;\r\n            right: 0px;\r\n            bottom: 0px;\r\n            left: 0px;\r\n            z-index: 2;\r\n        }\r\n\r\n        .color-picker-float {\r\n            position: absolute;\r\n            outline: 1px solid black;\r\n        }\r\n\r\n        .color-picker-container {\r\n            background-color: #e2e2e2;\r\n        }\r\n\r\n        input:focus {\r\n            outline-color: black;\r\n        }\r\n    }\r\n\r\n    .floatLine input,\r\n    .listLine select {\r\n        background-color: #000000;\r\n        color: white;\r\n        padding: 5px;\r\n        border: none;\r\n    }\r\n\r\n    input,\r\n    .listLine select {\r\n        outline-color: transparent;\r\n        outline-width: 1px;\r\n        outline-offset: -1px;\r\n        outline-style: solid;\r\n        transition: 0.2s outline;\r\n        border: none;\r\n    }\r\n\r\n    .floatLine .value {\r\n        position: relative;\r\n        margin: 5px;\r\n    }\r\n\r\n    .floatLine input:focus {\r\n        outline-color: white;\r\n    }\r\n\r\n    .listLine select {\r\n        width: 150px;\r\n    }\r\n\r\n    .hasArrows {\r\n        .arrows {\r\n            display: none;\r\n            position: absolute;\r\n            right: 0;\r\n            top: 0;\r\n            flex-direction: column;\r\n            cursor: grab;\r\n            filter: brightness(10);\r\n            .downArrowIcon,\r\n            .upArrowIcon {\r\n                width: 13px;\r\n                height: 13px;\r\n            }\r\n        }\r\n        &:hover .arrows,\r\n        &:focus .arrows,\r\n        &.dragging .arrows {\r\n            display: flex;\r\n        }\r\n        .arrows:hover {\r\n            background-color: var(--buttonHoverBackground);\r\n            filter: none;\r\n        }\r\n        &.dragging .arrows {\r\n            background-color: var(--buttonPressedBackground);\r\n            .downArrowIcon,\r\n            .upArrowIcon {\r\n                filter: none;\r\n            }\r\n        }\r\n    }\r\n    .hasArrows input::-webkit-outer-spin-button,\r\n    .hasArrows input::-webkit-inner-spin-button {\r\n        -webkit-appearance: none;\r\n        margin: 0;\r\n    }\r\n\r\n    .hasArrows input[type=\"number\"] {\r\n        -moz-appearance: textfield;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
